module.exports = __webpack_public_path__ + "static/img/ls31.9706efb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls31.png
// module id = A3u8
// module chunks = 12